//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'InputField',
  props: {
    value: '',
    label: String,
    name: String,
    placeholder: String,
    min: '',
    error: '',
    start_time: String,
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value);
    },
    render: function(){
      const self = this;
      $(this.$refs.timepicker).timepicker({
        timeFormat: 'HH:mm',
        interval: 30,
        startTime: '00:00',
        dynamic: true,
        dropdown: true,
        scrollbar: true,
        change: function(time){
          const timepicker = $(this).timepicker();
          self.updateValue(timepicker.format(time));
        },
      });
    },
  },
  mounted: function(){
    const self = this;
    $(this.$refs.timepicker).timepicker({
      timeFormat: 'HH:mm',
      interval: 30,
      startTime: '00:00',
      dynamic: false,
      dropdown: true,
      scrollbar: true,
      change: function(time){
        const timepicker = $(this).timepicker();
        self.updateValue(timepicker.format(time));
      },
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/fields/TimeField.vue